// extracted by mini-css-extract-plugin
module.exports = {"flashItem":"styles_flashItem__SFnbT","flashItem__link":"styles_flashItem__link__bchEz","regular":"styles_regular__AZWWD","large":"styles_large__azG4d"};